import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "20",
  viewBox: "0 0 15 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.08984 3.7677C4.08984 4.60404 4.42208 5.40613 5.01346 5.99751C5.60485 6.5889 6.40694 6.92113 7.24328 6.92113C8.07963 6.92113 8.88171 6.5889 9.4731 5.99751C10.0645 5.40613 10.3967 4.60404 10.3967 3.7677C10.3967 2.93135 10.0645 2.12926 9.4731 1.53788C8.88171 0.946494 8.07963 0.614258 7.24328 0.614258C6.40694 0.614258 5.60485 0.946494 5.01346 1.53788C4.42208 2.12926 4.08984 2.93135 4.08984 3.7677Z",
      fill: "#454342"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.304688 19.2407H2.82744H11.6571H14.1798V10.4111C14.1798 10.4111 11.6571 8.51904 7.24225 8.51904C2.82744 8.51904 0.304688 10.4111 0.304688 10.4111V19.2407Z",
      fill: "#454342"
    }, null, -1)
  ])))
}
export default { render: render }